import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconReceiptionBell2: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconReceiptionBell2"><Path d="M2 19.5H22" stroke="currentColor"/><Path d="M12 16.5V19.5" stroke="currentColor" strokeLinecap="square"/><Path d="M12 6V4" stroke="currentColor" strokeLinecap="square"/><Path d="M9 3.5L15 3.5" stroke="currentColor"/><Path d="M12 6C6.24242 6 2.5 10.701 2.5 16.5H21.5C21.5 10.701 17.7576 6 12 6Z" stroke="currentColor"/></CentralIconBase>;
});

export default IconReceiptionBell2;
